import axios from "../../config/axiosConfig";
import { IMPORT_BANK_STATEMENT_REQUEST, IMPORT_BANK_STATEMENT_SUCCESS, IMPORT_BANK_STATEMENT_REQUEST_FAILURE } from "../types";


export const importBankStatementsData = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: IMPORT_BANK_STATEMENT_REQUEST });
      return axios.post("/bank-statement/import", data,
        { params: {
            userId: auth.user?.id,
            customerId: auth.customer?.id,
            companyId: auth.company?.id,
            finyearId: auth.finyear?.id,
            commonMaster: auth.company?.Common_Master
        }}).then((response) => {
          if (response.data) {
            dispatch({ type: IMPORT_BANK_STATEMENT_SUCCESS });
          } else {
            dispatch({
              type: IMPORT_BANK_STATEMENT_REQUEST_FAILURE,
              error: "Import bank statements data failed.",
            });
          }
          return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: IMPORT_BANK_STATEMENT_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: IMPORT_BANK_STATEMENT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};